module.exports = __webpack_public_path__ + "img/AccesDenied.34d87232.png";